import React, { memo, useMemo } from "react";

interface StructuredDataProps {
  children: any;
}

const StructureData: React.FC<StructuredDataProps> = ({ children }) => {
  const structuredData = useMemo(() => {
    return JSON.stringify({
      "@context": "https://schema.org",
      ...children
    });
  }, [children]);

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: structuredData }}
    />
  );
};

export default memo(StructureData);
